import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError, from } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthenticationService } from '../services/auth.service';
import { AnalyticsService } from '../services/analytics.service';
import { AnalyticsContextService } from '../services/analytics-context.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    private analytics = inject(AnalyticsService);
    private analyticsContext = inject(AnalyticsContextService);
    private router = inject(Router);

    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError(err => {
                // Get user context asynchronously
                return from(this.analyticsContext.get()).pipe(
                    switchMap(context => {
                        // Log HTTP errors to analytics with context
                        this.analytics.logEvent('error_monitoring', {
                            action: 'http_error',
                            status_code: err.status,
                            error_message: err.message || err.statusText,
                            url: request.url,
                            method: request.method,
                            current_route: this.router.url,
                            ...context
                        });

                        if (err.status === 401) {
                            // Track unauthorized access attempts
                            this.analytics.logEvent('error_monitoring', {
                                action: 'unauthorized_access',
                                url: request.url,
                                current_route: this.router.url,
                                ...context
                            });

                            // auto logout if 401 response returned from api
                            this.authenticationService.logout();
                            location.reload();
                        }

                        const error = err.error.message || err.statusText;
                        return throwError(() => error);
                    })
                );
            })
        );
    }
}
